var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"vehicle-list",attrs:{"title":"Vehicles"}},[_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Aktive',
			value: 'active'
		},
		{
			label: 'Planlægning',
			value: 'planning'
		},
		{
			label: 'Tracking',
			value: 'tracking'
		},
		{
			label: 'Inaktive',
			value: 'inactive'
		}
	]},slot:"tools",model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_c('button-view',{attrs:{"slot":"tools","label":"Opret"},on:{"click":_vm.createButtonClick},slot:"tools"}),_c('new-table-view',{ref:"table",attrs:{"columns":[
		{
			label: 'Navn',
			name: 'name'
		},
		{
			label: 'Registreringsnummer',
			name: 'reg_no'
		},
		{
			label: 'Mærke',
			name: 'make'
		},
		{
			label: 'Model',
			name: 'model'
		},
		{
			label: '',
			name: 'delete',
			align: 'right',
			template: {
				name: 'button',
				label: 'Slet'
			}
		}
	],"items":_vm._items,"actions":_vm.actions},on:{"itemClick":_vm.itemClick,"delete":_vm.itemDelete,"action":_vm.action}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }